/*
 * Copyright (c) 2023 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";

interface Props {
  className?: string;
}

export const LanguageSelectorIcon = ({ className }: Props) => (
  <div className={className}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00008 0.666656C3.93341 0.666656 0.666748 3.93332 0.666748 7.99999C0.666748 12.0667 3.93341 15.3333 8.00008 15.3333C12.0667 15.3333 15.3334 12.0667 15.3334 7.99999C15.3334 3.93332 12.0667 0.666656 8.00008 0.666656ZM13.9334 7.33333H11.2667C11.1334 5.46666 10.5334 3.73333 9.46674 2.19999C11.8667 2.79999 13.6667 4.86666 13.9334 7.33333ZM10.0001 8.66666H6.06675C6.20008 10.4667 6.86675 12.2 8.06675 13.6C9.13341 12.2 9.80008 10.4667 10.0001 8.66666ZM6.06675 7.33333C6.26675 5.53333 6.93341 3.8 8.00008 2.4C9.13341 3.86666 9.80008 5.6 9.93341 7.33333H6.06675ZM4.73341 7.33333C4.86675 5.46666 5.46675 3.73333 6.46675 2.19999C4.13341 2.79999 2.33341 4.86666 2.06675 7.33333H4.73341ZM2.06675 8.66666H4.73341C4.86675 10.5333 5.46675 12.2667 6.53341 13.8C4.13341 13.2 2.33341 11.1333 2.06675 8.66666ZM11.3334 8.66666C11.1334 10.5333 10.5334 12.2667 9.53342 13.8C11.8668 13.2 13.6668 11.1333 14.0001 8.66666H11.3334Z"
        fill="white"
      />
    </svg>
  </div>
);
